<template>
  <div id="introducao">
    <div class="conteudo-dicas" :class="{'hidden':isError}">
      <DicasSelfie></DicasSelfie>
      <div class="clearfix"></div>
      <div id="footer">
        <button
            type="button"
            v-on:click="openMOdal()"
            class="btn btn-primary btn-lg btn-block"
        >
          Tirar a foto
        </button>
      </div>
    </div>


    <div class="page-error" :class="{'hidden':!isError}">
      <Error
          title="Não conseguimos acessar sua câmera"
          subtitle="Precisamos desse acesso pra tirar a foto e confirmar sua identidade"
          button-text="Permitir acesso à câmera"
          v-bind:callback="this.acaoBtnTentarNovamente"
      ></Error>
    </div>


    <ModalCamera
        v-bind:callback-confirm-button="allow"
        v-bind:callbackCloseButton="refuse">
    </ModalCamera>
  </div>
</template>
<script>
import DicasSelfie from "../shared/DicasSelfie";
import Error from "../shared/Error";
import ModalCamera from "../shared/ModalCamera";

export default {
  name: "SelfieIntroducao",
  components: { DicasSelfie, Error, ModalCamera },
  mounted() {
    this.$store.dispatch("setTitulo", "Confirmar identidade");
    this.$store.dispatch("setLoadingStatus", false);
  },
  data: function () {
    return {
      isError:false
    };
  },
  computed: {},
  methods: {
    openMOdal:function (){
      ModalCamera.methods.show();
    },
    nextPage: function () {
      this.$router.push({ name: "Selfie" });
    },
    getPermissaoCamera: function (){
      return new Promise((resolve,reject) => {
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          const getCameraPermission = navigator.mediaDevices.getUserMedia({ video: true });
          getCameraPermission.then(function(stream) {
            stream.getTracks().forEach(function (track) {
              track.stop();
            });
            resolve();
          }).catch(_ =>  reject());
        } else {
          reject()
        }
      })
    },
    allow:function (){
      this.getPermissaoCamera()
          .then(_ => this.nextPage())
          .catch(_ =>  this.refuse());
    },
    refuse:function (){
      this.isError = true;
    },
    acaoBtnTentarNovamente:function (){
     this.allow();
    }
  },
};
</script>

<style scoped>
.hidden{
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/SelfieIntroducao.vue